module.exports = __webpack_public_path__ + "static/media/medallaBronce.f6438537.png";